import { PortfolioType } from "lib/types";
import SponsoredBanner from "./SponsoredBanner";
import UnsponsoredBanner from "./UnsponsoredBanner";

interface Props {
  portfolio: PortfolioType;
  sponsored: boolean;
  type: string;
  category: string;
  scheme_sponsored: boolean;
  resultId: number;
}

const Sponsored = ({sponsored,portfolio,type,category, scheme_sponsored, resultId}:Props) => {
    if(sponsored === false || scheme_sponsored  === false) {
        let catMap = {
            HS:'High Street',
            SC:'Shopping Centres',
            RW:'Retail Warehousing',
            LE:'Leisure',
            OF:'Offices',
            SO:'Serviced Offices',
            BP:'Business Parks',
            SP:'Science Parks',
            TP:'trade Parks',
            IN:'Industrial Parks',
            WA:'Warehousing',
            WO:'Workshops',
            LO:'Logistics',
            HB:'Transport Hub',
            AP:'Flats and Apartments',
            HO:'Houses'
        }

        let unsponsoredText = "This scheme is not sponsored by the landlord so this scheme has limited information. To find out the benefits of Scheme Sponsorship click here."

        if(type == 'property'){
            let cat = '';
            if(category in catMap){
                cat = `${catMap[category].toLowerCase()} `
            }
            unsponsoredText = `This property is part of a ${cat}scheme that is not sponsored and therefore has limited information. To find out the benefits of Scheme Sponsorship click here.`
        }

       return ( <UnsponsoredBanner unsponsoredText={unsponsoredText} id={resultId}/> );
    }

    if(!portfolio?.id || !portfolio.sponsored) return null;

    const logo = portfolio.active && portfolio.advertise && portfolio.sponsored  ? `/images/portfolios/${portfolio.uri.toLowerCase()}/logo.svg` : `${process.env.NEXT_PUBLIC_APP_MEDIA_URL}${portfolio.logo_uri}`

    return (
        <SponsoredBanner id={portfolio.id} resultId={resultId} dark={portfolio?.styles?.dark} name={portfolio.name} url={portfolio.url}  logo_uri={logo} />
    )
};

export default Sponsored;

